import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { ShoppingCart, X } from 'lucide-react';

export const ProductModal = ({ product, open, onClose, onAddToCart }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  
  if (!product) return null;

  const allImages = [product.image, ...(product.images || [])];
  const finalPrice = product.discount > 0 
    ? Math.round(product.price * (1 - product.discount / 100))
    : product.price;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl bg-slate-900 border-slate-700">
        <DialogHeader>
          <DialogTitle className="text-white text-2xl">{product.name}</DialogTitle>
        </DialogHeader>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Galería de imágenes */}
          <div className="space-y-4">
            <div className="aspect-square rounded-lg overflow-hidden bg-slate-800">
              <img 
                src={allImages[selectedImage]} 
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
            
            {allImages.length > 1 && (
              <div className="grid grid-cols-6 gap-2">
                {allImages.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setSelectedImage(idx)}
                    className={`aspect-square rounded overflow-hidden border-2 ${
                      selectedImage === idx ? 'border-cyan-500' : 'border-slate-700'
                    }`}
                  >
                    <img src={img} alt={`Vista ${idx + 1}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Información del producto */}
          <div className="space-y-4">
            <div>
              <h3 className="text-slate-400 text-sm mb-2">Descripción</h3>
              <p className="text-white">{product.description}</p>
            </div>

            <div>
              <h3 className="text-slate-400 text-sm mb-2">Categoría</h3>
              <span className="text-white bg-slate-800 px-3 py-1 rounded-full text-sm">
                {product.category}
              </span>
            </div>

            <div className="border-t border-slate-700 pt-4">
              {product.discount > 0 ? (
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <span className="text-slate-400 line-through text-lg">
                      {product.currency} ${product.price.toLocaleString()}
                    </span>
                    <span className="bg-red-600 text-white px-2 py-1 rounded text-sm font-bold">
                      -{product.discount}%
                    </span>
                  </div>
                  <div className="text-3xl font-bold text-emerald-400">
                    {product.currency} ${finalPrice.toLocaleString()}
                  </div>
                </div>
              ) : (
                <div className="text-3xl font-bold text-cyan-400">
                  {product.currency} ${product.price.toLocaleString()}
                </div>
              )}
            </div>

            <div className="flex gap-3">
              <Button
                onClick={() => {
                  onAddToCart(product);
                  onClose();
                }}
                className="flex-1 bg-gradient-to-r from-cyan-600 to-emerald-600 hover:from-cyan-500 hover:to-emerald-500 text-lg py-6"
                disabled={!product.stock}
              >
                <ShoppingCart className="mr-2 h-5 w-5" />
                {product.stock ? 'Agregar al Carrito' : 'Sin Stock'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductModal;
